import { MtGroup, MtProjectGroup, MtUser } from "server/models"
import { CommonPermissionsSectioned } from "client/store/utils"
import {
    GroupFilters,
    ProjectGroupFilters,
    UserFilters,
} from "client/store"
import { OrderType } from "client/utils"


export interface LifecyclePermissionsState {
    lifecyclePermissions: CommonPermissionsSectioned

    accountGroups: {
        groupIds: readonly number[]
        sortColumn: keyof MtGroup
        sortOrder: OrderType
        filters: GroupFilters
        selected: readonly number[]
    }
    projectGroups: {
        groupIds: readonly number[]
        sortColumn: keyof MtProjectGroup
        sortOrder: OrderType
        filters: ProjectGroupFilters
        selected: readonly number[]
    }
    users: {
        userIds: readonly number[]
        sortColumn: keyof MtUser
        sortOrder: OrderType
        filters: UserFilters
        selected: readonly number[]
    }

    reloadList: boolean
}

export const SET_LIFECYCLE_PERMISSIONS = "SET_LIFECYCLE_PERMISSIONS"

export const UPDATE_LIFECYCLE_PERMISSION = "UPDATE_LIFECYCLE_PERMISSION"
export const TOGGLE_LIFECYCLE_PERMISSION_CUSTOMIZABLE = "TOGGLE_LIFECYCLE_PERMISSION_CUSTOMIZABLE"

export const LIFECYCLE_PERMISSIONS_ACCOUNT_GROUP_IDS = "LIFECYCLE_PERMISSIONS_ACCOUNT_GROUP_IDS"
export const LIFECYCLE_PERMISSIONS_ACCOUNT_GROUP_SORT = "LIFECYCLE_PERMISSIONS_ACCOUNT_GROUP_SORT"
export const LIFECYCLE_PERMISSIONS_ACCOUNT_GROUP_FILTERS = "LIFECYCLE_PERMISSIONS_ACCOUNT_GROUP_FILTERS"
export const LIFECYCLE_PERMISSIONS_ACCOUNT_GROUP_SELECTED = "LIFECYCLE_PERMISSIONS_ACCOUNT_GROUP_SELECTED"

export const LIFECYCLE_PERMISSIONS_PROJECT_GROUP_IDS = "LIFECYCLE_PERMISSIONS_PROJECT_GROUP_IDS"
export const LIFECYCLE_PERMISSIONS_PROJECT_GROUP_SORT = "LIFECYCLE_PERMISSIONS_PROJECT_GROUP_SORT"
export const LIFECYCLE_PERMISSIONS_PROJECT_GROUP_FILTERS = "LIFECYCLE_PERMISSIONS_PROJECT_GROUP_FILTERS"
export const LIFECYCLE_PERMISSIONS_PROJECT_GROUP_SELECTED = "LIFECYCLE_PERMISSIONS_PROJECT_GROUP_SELECTED"

export const LIFECYCLE_PERMISSIONS_USER_IDS = "LIFECYCLE_PERMISSIONS_USER_IDS"
export const LIFECYCLE_PERMISSIONS_USER_SORT = "LIFECYCLE_PERMISSIONS_USER_SORT"
export const LIFECYCLE_PERMISSIONS_USER_FILTERS = "LIFECYCLE_PERMISSIONS_USER_FILTERS"
export const LIFECYCLE_PERMISSIONS_USER_SELECTED = "LIFECYCLE_PERMISSIONS_USER_SELECTED"

export const LIFECYCLE_PERMISSIONS_RELOAD_LIST = "LIFECYCLE_PERMISSIONS_RELOAD_LIST"
